<template>
  <div :class="['bi-tip-message-box', isShow ? 'message-show' : '']">
    <div class="bi-tip-message-content" :style="tipStyle">
      {{msg}}</div>
  </div>
</template>

<script>
export default {
  props: {
    // msg: {
    //   type: String,
    //   default: "",
    // },
    // msgType: {
    //   type: String,
    //   default: "success",
    //   // ['error','success','info','warning']
    // },
    // 单位 ms
    delayCloseTime: {
      type: Number,
      default: 2500,
    },
  },
  data() {
    return {
      isShow: false,
      msg: "",
      msgType: "info",
    };
  },
  computed: {
    tipStyle() {
      let obj = {
        error: {
          backgroundColor: "#fa3534",
          color: "#FFFFFF",
        },
        warning: {
          backgroundColor: "#ff9900",
          color: "#FFFFFF",
        },
        success: {
          backgroundColor: "#19be6b",
          color: "#FFFFFF",
        },
        info: {
          backgroundColor: "#909399",
          color: "#FFFFFF",
        },
      };

      return {
        ...obj[this.msgType],
      };
    },
  },
  methods: {
    showMessage({ msg, msgType }) {
      this.msg = msg;
      this.msgType = msgType;
      if (!msg) {
        return;
      }
      if (this.setHideFun) {
        clearTimeout(this.setHideFun);
      }
      this.isShow = true;
      this.delayHide();
    },
    hideMessage() {
      if (this.setHideFun) {
        clearTimeout(this.setHideFun);
      }
      this.isShow = false;
    },
    delayHide() {
      const that = this
      this.setHideFun = null;
      this.setHideFun = setTimeout(function () {
        that.isShow = false;
      }, this.delayCloseTime);
    },
  },
};
</script>

<style lang="scss" scoped >
.bi-tip-message-box {
  position: fixed;
  top: -80px;
  left: 50%;
  z-index: 20;
  width: 100%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  transition: top 300ms ease-in-out;
  .bi-tip-message-content {
    border-radius: 5px;
    padding: 10px 20px;
  }
}
.message-show {
  top: 80px;
}
</style>